import React,{useState} from "react";
import css from "./FieldHeader.module.css";
import TypeText from "../../../TypeText/TypeText";
import {Badge} from "Components";
import {chevron0} from "Assets";


export default function FieldHeader(props){
    const {field,expandable}=props,{name,type,required}=field;
    const [expanded,setExpanded]=useState(expandable&&props.expanded);
    const typename=typeof(type)==="string"?type:type?.name;
    return (
        <header 
            className={`${css.fieldheader} ${props.className||""}`} 
            expandable={expandable&&""}
            onClick={expandable?(()=>{setExpanded(!expanded)}):undefined}
        >
            {expandable&&<img 
                className={css.icon} alt=">"
                src={chevron0(textColor,2)}
                style={{transform:`rotateZ(${expanded?270:180}deg)`}}
            />}
            <span className={css.name}>{name}</span>
            {required&&<Badge className={css.badge} text="required"/>}
            {typename&&
                <TypeText
                    style={{color:[":","|"].some(char=>typename.includes(char))?minorColor:mainColor}}
                    type={type||"any"}
                />
            }
        </header>
    )
}
